import { __rest } from "tslib";
import React from 'react';
import { StepTypeIcon } from './StepTypeIcon';
export function YesOrNoIcon(_a) {
    var { isDisabled = false } = _a, props = __rest(_a, ["isDisabled"]);
    return (React.createElement(StepTypeIcon, Object.assign({ bg: isDisabled ? 'slate7' : 'violet6', color: isDisabled ? 'slate8' : 'violet12' }, props),
        React.createElement("path", { d: "m29.976 20.8974c.0902-.5547-.0768-1.1195-.4569-1.5458-.3802-.4264-.9355-.6715-1.5198-.6709h-4.4295c-.1676 0-.3035-.1306-.3035-.2917v-2.5141c-.0001-.8353-.5752-1.5697-1.4104-1.8013-.8352-.2315-1.7292.0958-2.1922.8026l-2.9069 4.3738h-3.1497c-.3353 0-.6071.2612-.6071.5834v7.5832c0 .3222.2718.5834.6071.5834h13.4281c.9858.0056 1.8267-.6842 1.9755-1.6205z" })));
}
